module.exports = {
          srcSet: __webpack_public_path__ + "73f7d73e.jpg"+" 700w"+","+__webpack_public_path__ + "739d8858.jpg"+" 1400w"+","+__webpack_public_path__ + "b03b5cb3.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "73f7d73e.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "739d8858.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "b03b5cb3.jpg",width: 2048,height: 1366}],
          src: __webpack_public_path__ + "73f7d73e.jpg",
          toString:function(){return __webpack_public_path__ + "73f7d73e.jpg"},
          
          width: 700,
          height: 467
        }